import React from "react";
import Header from "../components/Header";
import Podcast from "../components/Podcast";
import CoreValues from "../components/CoreValues";
import Salvation from "../components/Salvation";
import Mission from "../components/Mission";
import News from "../components/News";
import Footer from "../components/Footer";

export default function Media() {
  return (
    <div>
      <Header />
      <hr className="g-brd-gray-light-v4 my-0" />

      <section className="g-bg-white">
        <div className="container g-py-75">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h1 className="g-font-weight-300 g-letter-spacing-1 g-mb-10">
                Media
              </h1>
              <p className="g-font-size-16 g-color-gray-dark-v2 g-mb-25">
                We’re building this section now. Soon you’ll find sermons, videos, photos,
                and special announcements here.
              </p>

              <div className="g-brd-around g-brd-gray-light-v4 g-bg-white g-pa-30">
                <h3 className="h5 g-mb-10">Coming Soon</h3>
                <p className="mb-0 g-color-gray-dark-v2">
                  Check back soon — or visit the News section below for updates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Podcast />
      <CoreValues />
      <Salvation />
      <Mission />
      <News />
      <Footer />
    </div>
  );
}